<!----
    Author: hjlee
    Description:
        포인트 컨트롤
---->
<template>
  <b-input-group
    :prepend="$t('point.text.position') === 'prefix' ? $t('point.text.unit') : ''"
    :append="$t('point.text.position') === 'suffix' ? $t('point.text.unit') : ''"
    class="point-control"
  >
    <b-form-input
      v-model="inputVal"
      :name="name"
      type="number"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="$t('point.text.unit')"
      @input="onInput($event)"
      @change="onChanged($event)"
    />
  </b-input-group>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      inputVal: 0,
      uid: this._uid
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.inputVal = newVal
      },
      immediate: true
    }
  },
  methods: {
    onChanged(e) {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
    },
    onInput(e) {
      this.$emit('input', this.inputVal)
    }
  }
}
</script>

<style scoped>
.input-group.form-control {
  padding: 0 !important;
}
.point-control {
  min-height: 37px;
}
</style>
